import { decodeTokenService } from "../services/decodeTokenService";

export const BRAND_FEATURE_ALLOWED_EMAIL = "proyectosneuropublico@gmail.com";

export const canUseBrandFeature = () => {
  try {
    return (
      decodeTokenService.getEmailFromToken()?.trim().toLowerCase() ===
      BRAND_FEATURE_ALLOWED_EMAIL
    );
  } catch {
    return false;
  }
};
